"use strict";
// Available products (loan, credit card, etc)
Object.defineProperty(exports, "__esModule", { value: true });
exports.MortgageLoanTypeNames = exports.MortgageLoanType = exports.SortDirection = exports.MANDATORY_REDIRECT_SPECIAL_OFFER_PARTNER_NAME = exports.LifeInsuranceSortOptionValues = exports.LifeInsuranceSortOption = exports.CompactDepositsSortOptionValues = exports.CompactDepositsSortOption = exports.DepositsSortOptionValues = exports.DepositsSortOption = exports.CreditSortOptionNonUI = exports.CreditSortOptionsWithRewardsUIValues = exports.CreditSortOptionUIValues = exports.CreditSortOptionUI = exports.TermUnit = exports.LoanSortOptionWithClosestAmountValues = exports.RelevanceLoanSortWithAmountOptionValues = exports.LoanSortOptionWithAmountValues = exports.LoanSortOptionWithConversionProbabilityValues = exports.RelevanceLoanSortOptionValues = exports.LoanSortOptionValues = exports.LoanSortOption = exports.OfferType = exports.PRODUCT_NAMES = exports.ConsumerProductPath = exports.LenderIdKeys = exports.ProductApiKeys = exports.ProductResponseKeys = exports.ConfigProductToProduct = exports.ProductToApiProduct = exports.ApiProductToProduct = exports.ConfigProductType = exports.ApiProductType = void 0;
const productsKeys_1 = require("./productsKeys");
var ApiProductType;
(function (ApiProductType) {
    ApiProductType["CreditCard"] = "creditCard";
    ApiProductType["Loan"] = "loan";
    ApiProductType["Mortgage"] = "mortgage";
    ApiProductType["Deposits"] = "savings";
    ApiProductType["LifeInsurance"] = "lifeInsurance";
})(ApiProductType = exports.ApiProductType || (exports.ApiProductType = {}));
// What the config service uses as product keys
var ConfigProductType;
(function (ConfigProductType) {
    ConfigProductType["AutomobileRefinance"] = "automobile_refinance";
    ConfigProductType["CreditCard"] = "credit_card";
    ConfigProductType["Loan"] = "loan";
    ConfigProductType["Mortgage"] = "mortgage";
    ConfigProductType["Deposits"] = "savings";
    ConfigProductType["LifeInsurance"] = "life_insurance";
    ConfigProductType["StudentLoanRefinance"] = "student_loan_refinance";
    ConfigProductType["SpecialOffers"] = "special_offers";
})(ConfigProductType = exports.ConfigProductType || (exports.ConfigProductType = {}));
// Mapping from ApiProductType -> Product
exports.ApiProductToProduct = {
    [ApiProductType.CreditCard]: productsKeys_1.Product.CreditCard,
    [ApiProductType.Loan]: productsKeys_1.Product.Loan,
    [ApiProductType.Mortgage]: productsKeys_1.Product.Mortgage,
    [ApiProductType.Deposits]: productsKeys_1.Product.Deposits,
    [ApiProductType.LifeInsurance]: productsKeys_1.Product.LifeInsurance,
};
// Mapping from Product -> ApiProductType
exports.ProductToApiProduct = {
    [productsKeys_1.Product.CreditCard]: ApiProductType.CreditCard,
    [productsKeys_1.Product.Loan]: ApiProductType.Loan,
    [productsKeys_1.Product.Mortgage]: ApiProductType.Mortgage,
    [productsKeys_1.Product.Deposits]: ApiProductType.Deposits,
    [productsKeys_1.Product.LifeInsurance]: ApiProductType.LifeInsurance,
};
// Mapping from ConfigProductType -> Product
exports.ConfigProductToProduct = {
    [ConfigProductType.AutomobileRefinance]: productsKeys_1.Product.Loan,
    [ConfigProductType.CreditCard]: productsKeys_1.Product.CreditCard,
    [ConfigProductType.Loan]: productsKeys_1.Product.Loan,
    [ConfigProductType.Mortgage]: productsKeys_1.Product.Mortgage,
    [ConfigProductType.Deposits]: productsKeys_1.Product.Deposits,
    [ConfigProductType.LifeInsurance]: productsKeys_1.Product.LifeInsurance,
    [ConfigProductType.StudentLoanRefinance]: productsKeys_1.Product.Loan,
};
// For some products the API return creditCardOffers when the product type is credit_card
exports.ProductResponseKeys = {
    [productsKeys_1.Product.CreditCard]: ApiProductType.CreditCard,
    [productsKeys_1.Product.Loan]: ApiProductType.Loan,
    [productsKeys_1.Product.Mortgage]: ApiProductType.Mortgage,
    [productsKeys_1.Product.Deposits]: ApiProductType.Deposits,
    [productsKeys_1.Product.LifeInsurance]: ApiProductType.LifeInsurance,
};
// Mapping from product to the name of the "productType" to send to the API
exports.ProductApiKeys = {
    [productsKeys_1.Product.CreditCard]: 'credit_card',
    [productsKeys_1.Product.Loan]: 'loan',
    [productsKeys_1.Product.Mortgage]: 'mortgage',
    [productsKeys_1.Product.Deposits]: 'savings',
    [productsKeys_1.Product.LifeInsurance]: 'life_insurance',
    [productsKeys_1.Product.Other]: 'other',
};
exports.LenderIdKeys = {
    [productsKeys_1.Product.Deposits]: 'partner.uuid',
    [productsKeys_1.Product.Loan]: 'originator.companyUuid',
};
// Urls for each product in the consumer website e.g. hifiona.com/loans
exports.ConsumerProductPath = {
    [productsKeys_1.Product.CreditCard]: 'credit-cards',
    [productsKeys_1.Product.Loan]: 'loans',
    [productsKeys_1.Product.Mortgage]: 'mortgages',
    [productsKeys_1.Product.Deposits]: 'savings',
    [productsKeys_1.Product.LifeInsurance]: 'life-insurance',
    Preferred: 'preferred',
    StudentLoanRefinancing: 'student-loan-refinancing',
};
exports.PRODUCT_NAMES = {
    [productsKeys_1.Product.CreditCard]: 'Credit Cards',
    [productsKeys_1.Product.Loan]: 'Personal Loans',
    [productsKeys_1.Product.Mortgage]: 'Mortgages',
    [productsKeys_1.Product.Deposits]: 'Deposits',
    [productsKeys_1.Product.LifeInsurance]: 'Life Insurance',
};
var OfferType;
(function (OfferType) {
    OfferType["CreditCard"] = "credit";
    OfferType["Deposits"] = "deposits";
    OfferType["LifeInsurance"] = "lifeInsurance";
    OfferType["Loan"] = "loan";
    OfferType["Mortgage"] = "mortgage";
    OfferType["Special"] = "special";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var LoanSortOption;
(function (LoanSortOption) {
    LoanSortOption["Recommended"] = "loanSortRecommended";
    LoanSortOption["Relevance"] = "loanSortRecommended";
    LoanSortOption["Lender"] = "loanSortLendingPartner";
    LoanSortOption["Term"] = "loanSortTerm";
    LoanSortOption["Apr"] = "loanSortApr";
    LoanSortOption["Payment"] = "loanSortPayment";
    LoanSortOption["Amount"] = "loanSortAmount";
    LoanSortOption["ConversionProbability"] = "loanSortConversionProbability";
    LoanSortOption["ClosestAmount"] = "loanSortClosestAmount";
})(LoanSortOption = exports.LoanSortOption || (exports.LoanSortOption = {}));
exports.LoanSortOptionValues = {
    [LoanSortOption.Recommended]: 'Recommended',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
};
exports.RelevanceLoanSortOptionValues = {
    [LoanSortOption.Relevance]: 'Relevance',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
};
exports.LoanSortOptionWithConversionProbabilityValues = {
    [LoanSortOption.ConversionProbability]: 'Recommended',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
};
exports.LoanSortOptionWithAmountValues = {
    [LoanSortOption.Recommended]: 'Recommended',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
    [LoanSortOption.Amount]: 'Loan Amount',
};
exports.RelevanceLoanSortWithAmountOptionValues = {
    [LoanSortOption.Relevance]: 'Relevance',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
    [LoanSortOption.Amount]: 'Loan Amount',
};
exports.LoanSortOptionWithClosestAmountValues = {
    [LoanSortOption.Recommended]: 'Recommended',
    [LoanSortOption.Lender]: 'Lending Partner',
    [LoanSortOption.Term]: 'Term',
    [LoanSortOption.Apr]: 'APR',
    [LoanSortOption.Payment]: 'Payment',
    [LoanSortOption.ClosestAmount]: 'Closest Amount',
};
var TermUnit;
(function (TermUnit) {
    TermUnit["Biweekly"] = "biweekly";
    TermUnit["Days"] = "day";
    TermUnit["Months"] = "month";
    TermUnit["Years"] = "year";
    TermUnit["Open"] = "open";
})(TermUnit = exports.TermUnit || (exports.TermUnit = {}));
var CreditSortOptionUI;
(function (CreditSortOptionUI) {
    CreditSortOptionUI["Recommended"] = "creditSortRecommended";
    CreditSortOptionUI["Rewards"] = "creditSortRewards";
    CreditSortOptionUI["Name"] = "creditSortCardName";
    CreditSortOptionUI["VariableApr"] = "creditSortVariableApr";
    CreditSortOptionUI["AnnualFee"] = "creditSortAnnualFee";
    CreditSortOptionUI["IntroApr"] = "creditSortIntroApr";
})(CreditSortOptionUI = exports.CreditSortOptionUI || (exports.CreditSortOptionUI = {}));
exports.CreditSortOptionUIValues = {
    [CreditSortOptionUI.Recommended]: 'Recommended',
    [CreditSortOptionUI.Name]: 'Card Name',
    [CreditSortOptionUI.VariableApr]: 'Variable APR',
    [CreditSortOptionUI.AnnualFee]: 'Annual Fee',
    [CreditSortOptionUI.IntroApr]: 'Intro APR',
};
exports.CreditSortOptionsWithRewardsUIValues = {
    [CreditSortOptionUI.Rewards]: 'Rewards',
    [CreditSortOptionUI.Recommended]: 'Recommended',
    [CreditSortOptionUI.Name]: 'Card Name',
    [CreditSortOptionUI.VariableApr]: 'Variable APR',
    [CreditSortOptionUI.AnnualFee]: 'Annual Fee',
    [CreditSortOptionUI.IntroApr]: 'Intro APR',
};
var CreditSortOptionNonUI;
(function (CreditSortOptionNonUI) {
    CreditSortOptionNonUI["PersonalizedStatus"] = "creditPersonalizedStatus";
    CreditSortOptionNonUI["SupportsPreSelect"] = "creditSupportsPreSelect";
    CreditSortOptionNonUI["SupportsPersonalization"] = "creditSupportsPersonalization";
})(CreditSortOptionNonUI = exports.CreditSortOptionNonUI || (exports.CreditSortOptionNonUI = {}));
var DepositsSortOption;
(function (DepositsSortOption) {
    DepositsSortOption["Recommended"] = "depositsSortRecommended";
    DepositsSortOption["APY"] = "depositsSortApy";
    DepositsSortOption["Minimum"] = "depositsSortMinimums";
    DepositsSortOption["Partner"] = "depositsPartner";
})(DepositsSortOption = exports.DepositsSortOption || (exports.DepositsSortOption = {}));
exports.DepositsSortOptionValues = {
    [DepositsSortOption.Recommended]: 'Recommended',
    [DepositsSortOption.APY]: 'APY',
    [DepositsSortOption.Minimum]: 'Minimums',
    [DepositsSortOption.Partner]: 'Banks/Institution',
};
var CompactDepositsSortOption;
(function (CompactDepositsSortOption) {
    CompactDepositsSortOption["APY"] = "compactDepositsSortApy";
})(CompactDepositsSortOption = exports.CompactDepositsSortOption || (exports.CompactDepositsSortOption = {}));
exports.CompactDepositsSortOptionValues = {
    [CompactDepositsSortOption.APY]: 'APY',
};
var LifeInsuranceSortOption;
(function (LifeInsuranceSortOption) {
    LifeInsuranceSortOption["Recommended"] = "recommended";
    LifeInsuranceSortOption["PolicyAmount"] = "policyAmount";
    LifeInsuranceSortOption["TermLength"] = "termLength";
    LifeInsuranceSortOption["MonthlyPremiumAmount"] = "monthlyPremiumAmount";
})(LifeInsuranceSortOption = exports.LifeInsuranceSortOption || (exports.LifeInsuranceSortOption = {}));
exports.LifeInsuranceSortOptionValues = {
    [LifeInsuranceSortOption.Recommended]: 'Recomended',
    [LifeInsuranceSortOption.PolicyAmount]: 'Policy Amount',
    [LifeInsuranceSortOption.TermLength]: 'Term Length',
    [LifeInsuranceSortOption.MonthlyPremiumAmount]: 'Monthly Premium Amount',
};
exports.MANDATORY_REDIRECT_SPECIAL_OFFER_PARTNER_NAME = 'Pick a Lender API';
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "asc";
    SortDirection["Desc"] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var MortgageLoanType;
(function (MortgageLoanType) {
    MortgageLoanType["FifteenYearFixed"] = "fifteen_year_fixed";
    MortgageLoanType["FiveOneAdjustable"] = "five_one_adjustable";
    MortgageLoanType["SevenOneAdjustable"] = "seven_one_adjustable";
    MortgageLoanType["TenOneAdjustable"] = "ten_one_adjustable";
    MortgageLoanType["ThirtyYearFixed"] = "thirty_year_fixed";
})(MortgageLoanType = exports.MortgageLoanType || (exports.MortgageLoanType = {}));
exports.MortgageLoanTypeNames = {
    [MortgageLoanType.FifteenYearFixed]: '15 Year Fixed',
    [MortgageLoanType.ThirtyYearFixed]: '30 Year Fixed',
    [MortgageLoanType.FiveOneAdjustable]: '5-1 Adjustable',
    [MortgageLoanType.SevenOneAdjustable]: '7-1 Adjustable',
    [MortgageLoanType.TenOneAdjustable]: '10-1 Adjustable',
};
//# sourceMappingURL=products.js.map